import React, { FunctionComponent as FC, useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux'; // To call Action Creators
import { State } from '../../../../../state';
import * as d3 from  "d3";
import cloud from 'd3-cloud';
import _ from 'lodash';
import './index.scss';

import { MainViewTypes } from '../../../../../types/data';
import { CitationFlowType, EntityType, ImpactType } from '../../../../../types/data.global';
import { VisualizationTypes } from '../../../../../types/data';
import { visualizationStyle } from '../../../../../types/style.global';
import { grantFieldCode2Name, cpcCode2Name, meshCode2Name, paperFieldCode2Name } from '../../../../../types/data.global';


interface WordleProps {
    totalWordleData: MainViewTypes.TotalWordleData;
}

const Wordle: React.FC<WordleProps> = (props) => {

    const { totalWordleData } = props

    // data reducer
    // const isShowWordle: boolean = true
    const isShowWordle: boolean = useSelector((state: State) => state.uiReducer?.isShowWordle) as boolean
    const wordlePosition: { left: number, top: number } = useSelector((state: State) => state.uiReducer?.wordlePosition) as { left: number, top: number }
    const wordleEntity: { entity: string, fieldID: string } = useSelector((state: State) => state.uiReducer?.wordleEntity) as { entity: string, fieldID: string }
    const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string
    const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string
    const selectedImpactEntityField: { [entity: string]: string } = useSelector((state: State) => state.uiReducer?.selectedImpactEntityField) as { [entity: string]: string }
    const predictionSearchResult: MainViewTypes.PredictionSearchResult = useSelector((state: State) => state.dataReducer?.predictionSearchResult) as MainViewTypes.PredictionSearchResult

    // state variables
    const [wordleData, setWordleData] = useState<MainViewTypes.EntityWordleDataUnit>({
        fieldCode: "",
        fieldName: "",
        data: []
    })

    // style variables
    const WORDLE_SIZE = visualizationStyle.Wordle.wordSize;
    const FONT_SIZE_RANGE = visualizationStyle.Wordle.fontSizeRange;
    const PADDING = visualizationStyle.Wordle.padding;

    const wordleRef = useRef<SVGSVGElement>(null);
    const wordleOpacity: number = (isShowWordle) ? 1 : 0
    const emptyWordleData:MainViewTypes.EntityWordleDataUnit = {
        fieldCode: "",
        fieldName: "",
        data: []
    }

    // console.log("==>totalWordleData[grantPredictionFlow]", totalWordleData["grantPredictionFlow"])
    // console.log("==> predictionSearchResult", predictionSearchResult)
    // console.log("==> totalWordleData", totalWordleData)
    // console.log("==> totalWordleData[grantHistoricalFlow]", totalWordleData["grantHistoricalFlow"])

    // render visualization
    useEffect(() => {
        var curWordleData:MainViewTypes.EntityWordleDataUnit = {
            fieldCode: "",
            fieldName: "",
            data: []
        }
        // console.log('totalWordleData', totalWordleData)
        var wordleTitle = ""
        if(wordleEntity.entity === EntityType.GRANT){
            // console.log("\n\n==> entity: grant,wordleEntity", wordleEntity)
            // console.log("==> citationFlowType", citationFlowType)
            // console.log("==> impactType", impactType)
            if(citationFlowType === CitationFlowType.HISTORICAL){
                // curWordleData = totalWordleData["grantHistoricalFlow"]["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData
                // wordleTitle = totalWordleData["grantHistoricalFlow"]["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? ""
                // setWordleData(curWordleData)
                if(impactType === ImpactType.DIRECT_IMPACT){
                    if(Object.keys(selectedImpactEntityField).length === 0){
                        curWordleData = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['directImpact']['totalWordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        const fieldCode = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['directImpact']["totalWordleData"].find((item) => String(item.fieldCode) === wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                    }
                    else{
                        curWordleData = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['directImpact']['entityType'][Object.keys(selectedImpactEntityField)[0]].find((item) => String(item.fieldCode) === Object.values(selectedImpactEntityField)[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        const fieldCode = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['directImpact']["entityType"][Object.keys(selectedImpactEntityField)[0]].find((item) => String(item.fieldCode) === Object.values(selectedImpactEntityField)[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                    }
                }
                else{
                    // indirect impact
                    if(Object.keys(selectedImpactEntityField).length === 0){
                        curWordleData = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['indirectImpact']['totalWordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        const fieldCode = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['indirectImpact']["totalWordleData"].find((item) => String(item.fieldCode) === wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                    }
                    else{
                      try {
                        curWordleData = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['indirectImpact']['entityType'][Object.keys(selectedImpactEntityField)[0]].find((item) => item.fieldCode === Object.values(selectedImpactEntityField)[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        const fieldCode = totalWordleData["grantHistoricalFlow"]["wordleData"]['data']['indirectImpact']["entityType"][Object.keys(selectedImpactEntityField)[0]].find((item) => item.fieldCode === Object.values(selectedImpactEntityField)[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                        // console.log("hover ==> curWordleData", curWordleData)
                      } catch (error) {
                        console.error(error)
                        curWordleData = emptyWordleData
                        wordleTitle = ""
                        setWordleData(curWordleData)
                        console.log("Error in hover ==> curWordleData", curWordleData)
                      }
                    }
                }
                // console.log("hover ==> totalWordleData[grantHistoricalFlow]", totalWordleData["grantHistoricalFlow"])
            }
            else if(citationFlowType === CitationFlowType.PREDICTION){
                // curWordleData = totalWordleData["grantPredictionFlow"]["wordleData"].find((item) => item.fieldCode ===  wordleEntity.fieldID) ?? emptyWordleData
                // wordleTitle = totalWordleData["grantPredictionFlow"]["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? ""
                // setWordleData(curWordleData)
                if(impactType === ImpactType.DIRECT_IMPACT){
                    if(predictionSearchResult.fieldIDList.length === 0){
                        curWordleData = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['directImpact']['totalWordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        const fieldCode = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['directImpact']["totalWordleData"].find((item) => String(item.fieldCode) === wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                    }
                    else{
                        curWordleData = totalWordleData?.["grantPredictionFlow"]?.["wordleData"]?.['data']?.['directImpact']?.['entityType']?.[predictionSearchResult.entity]
                          ?.find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])
                          ?.['wordleData']
                          ?.find((item) => String(item.fieldCode) === wordleEntity.fieldID)
                          ?? emptyWordleData

                        const fieldCode = totalWordleData?.["grantPredictionFlow"]?.["wordleData"]?.['data']?.['directImpact']?.["entityType"]?.[predictionSearchResult.entity]
                          ?.find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])
                          ?.['wordleData']
                          ?.find((item) => String(item.fieldCode) === wordleEntity.fieldID)?.fieldName ?? ""

                        // curWordleData = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['directImpact']['entityType'][predictionSearchResult.entity].find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        // const fieldCode = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['directImpact']["entityType"][predictionSearchResult.entity].find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                    }
                }
                else{
                    // indirect impact
                    if(predictionSearchResult.fieldIDList.length === 0){
                        curWordleData = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['indirectImpact']['totalWordleData'].find((item) => item.fieldCode ===  wordleEntity.fieldID) ?? emptyWordleData
                        const fieldCode = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['indirectImpact']["totalWordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode]

                        setWordleData(curWordleData)
                    }
                    else{
                      curWordleData = totalWordleData?.["grantPredictionFlow"]?.["wordleData"]?.['data']?.['indirectImpact']?.['entityType']?.[predictionSearchResult.entity]
                        ?.find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])
                        ?.['wordleData']
                        ?.find((item) => String(item.fieldCode) === wordleEntity.fieldID)
                        ?? emptyWordleData
                      const fieldCode = totalWordleData?.["grantPredictionFlow"]?.["wordleData"]?.['data']?.['indirectImpact']?.["entityType"]?.[predictionSearchResult.entity]
                        ?.find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])
                        ?.['wordleData']
                        ?.find((item) => String(item.fieldCode) === wordleEntity.fieldID)?.fieldName ?? ""


                        // curWordleData = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['indirectImpact']['entityType'][predictionSearchResult.entity].find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID) ?? emptyWordleData
                        // const fieldCode = totalWordleData["grantPredictionFlow"]["wordleData"]['data']['indirectImpact']["entityType"][predictionSearchResult.entity].find((item) => String(item.fieldCode) === predictionSearchResult.fieldIDList[0])?.['wordleData'].find((item) => String(item.fieldCode) ===  wordleEntity.fieldID)?.fieldName ?? ""
                        wordleTitle = grantFieldCode2Name[fieldCode] ?? ""

                        setWordleData(curWordleData)
                        // console.log("hover ==> curWordleData", curWordleData)
                    }
                }

                // console.log("hover ==> totalWordleData[grantPredictionFlow]", totalWordleData["grantPredictionFlow"])
            }
        }
        else if(wordleEntity.entity === EntityType.PAPER){
            // wordleTitle = grantFieldCode2Name[wordleEntity.fieldID]
            const paperWordleData = totalWordleData["directImpact"].find((item) => item.entityType === "paper");
            if (paperWordleData) {
                curWordleData = paperWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                const fieldCode = paperWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? ""
                const lowestFieldLevelCode = fieldCode.split('-').pop()
                wordleTitle = lowestFieldLevelCode ? paperFieldCode2Name[lowestFieldLevelCode] : fieldCode
            }
            setWordleData(curWordleData)
        }
        else if(wordleEntity.entity === EntityType.PATENT){
            // console.log('impactType', impactType)
            if(impactType === ImpactType.DIRECT_IMPACT){
                const patentWordleData = totalWordleData["directImpact"].find((item) => item.entityType === "patent");
                if (patentWordleData) {
                    curWordleData = patentWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                    const fieldCode = patentWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? ""
                    wordleTitle = cpcCode2Name[fieldCode]
                }
                setWordleData(curWordleData)
            }
            else{
                const patentWordleData = totalWordleData["indirectImpact"].find((item) => item.entityType === "patent");
                // console.log('patentWordleData', patentWordleData)
                if (patentWordleData) {
                    curWordleData = patentWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                    const fieldCode = patentWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? "";
                    wordleTitle = cpcCode2Name[fieldCode]
                }
                // console.log('curWordleData', curWordleData)
                setWordleData(curWordleData)
            }
        }
        else if(wordleEntity.entity === EntityType.CLINICAL_TRIAL){
            if(impactType === ImpactType.DIRECT_IMPACT){
                const clinicalTrialWordleData = totalWordleData["directImpact"].find((item) => item.entityType === "clinical_trial");
                if (clinicalTrialWordleData) {
                    curWordleData = clinicalTrialWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                    const fieldCode = clinicalTrialWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? "";
                    wordleTitle = meshCode2Name[fieldCode]
                }
                setWordleData(curWordleData)
            }
            else{
                const clinicalTrialWordleData = totalWordleData["indirectImpact"].find((item) => item.entityType === "clinical_trial");
                if (clinicalTrialWordleData) {
                    curWordleData = clinicalTrialWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                    const fieldCode = clinicalTrialWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? "";
                    wordleTitle = meshCode2Name[fieldCode]
                }
                setWordleData(curWordleData)
            }
        }
        else if(wordleEntity.entity === EntityType.POLICY){
            const policyWordleData = totalWordleData["indirectImpact"].find((item) => item.entityType === "policy");
            if (policyWordleData) {
                curWordleData = policyWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                wordleTitle = policyWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? "";
            }
            setWordleData(curWordleData)
        }
        else if(wordleEntity.entity === EntityType.NEWSFEED){
            const newsfeedWordleData = totalWordleData["indirectImpact"].find((item) => item.entityType === "newsfeed");
            if (newsfeedWordleData) {
                curWordleData = newsfeedWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID) ?? emptyWordleData;
                wordleTitle = newsfeedWordleData["wordleData"].find((item) => item.fieldCode === wordleEntity.fieldID)?.fieldName ?? "";
            }
            setWordleData(curWordleData)
        }
        if (curWordleData && curWordleData.data.length > 0) {
          // 扁平化数据并提取所有频率值
            const frequencies = curWordleData.data.map(dataUnit => dataUnit.frequency)

            // 计算最小值和最大值
            const maxFrequency = Math.max(...frequencies);
            const minFrequency = Math.min(...frequencies);

            // method 2
            // // 根据单词数量动态调整字体大小范围
            // const wordCount = curWordleData.data.length;
            // const scaleFactor = Math.max(0.4, Math.min(1.0, 20 / wordCount)); // 单词越多，字体越小

            // const adjustedFontSizeRange = [
            //     Math.max(FONT_SIZE_RANGE[0] * scaleFactor * 0.8, 8), // 动态最小字体
            //     Math.min(FONT_SIZE_RANGE[1] * scaleFactor * 0.9, 28)  // 动态最大字体
            // ];

            // method 1
            // 定义 scaleLinear 比例尺
            const fontSizeScale = d3.scalePow()
                                    .domain([minFrequency, maxFrequency]) // 动态设置输入域
                                    // method 1
                                    .range([FONT_SIZE_RANGE[0], FONT_SIZE_RANGE[1]]) // 输出范围，可以根据实际需要调整
                                    .exponent(0.5) // 指数值，可以根据实际需要调整

                                    // method 2
                                    // .range(adjustedFontSizeRange) // 使用调整后的字体大小范围
                                    // .exponent(0.6) // 稍微调整指数，使大小差异更平缓

            const words: VisualizationTypes.WordleTypes.Word[] = curWordleData.data.map(dataUnit => ({
                text: dataUnit.word, // 直接访问 word 属性
                size: fontSizeScale(dataUnit.frequency), // 调用 fontSizeScale 函数计算 size
                // 如果 timeline 非空，使用原 timeline，否则使用默认值
                timeline: dataUnit.timeline.length !== 0 ? dataUnit.timeline : [{ time: "", value: 0 }]
            }));
            // console.log('words', words.map(word =>word.text))

            const fill = d3.schemeCategory10;
            const wordleColor = wordleEntity.entity === EntityType.GRANT ? (citationFlowType === CitationFlowType.HISTORICAL ? "#B08968" : "#AE7BAC") : "#B08968"
            const wordleTitleBgColor = 'white'
            // const wordleTitleBgColor = wordleEntity.entity === EntityType.GRANT ? (citationFlowType === CitationFlowType.HISTORICAL ? "white" : "#AE7BAC" ) : "white"
            // const wordleTitleBgColor = wordleEntity.entity === EntityType.GRANT ? (citationFlowType === CitationFlowType.HISTORICAL ? "#ddb892" : "#AE7BAC" ) : "#ddb892"

            const svgElementRoot = d3.select(wordleRef.current);
            svgElementRoot.selectAll("*").remove(); // Clear previous wordle

            const wordleMargin = 20
            const svgElement = svgElementRoot
                .append("g")
                .attr("transform", `translate(${wordleMargin}, ${wordleMargin})`) // Adjust as needed

            // 添加遮罩和边框的定义
            const defs = svgElement.append("defs");

            // 定义一个遮罩
            defs.append("clipPath")
                .attr("id", "wordleMask")
                .append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", WORDLE_SIZE / 2); // 使遮罩半径稍小于边框半径

            // 添加一个圆形边框
            const borderGap = 15
            svgElement.append("circle")
                .attr("id", "wordle_border")
                .attr("cx", WORDLE_SIZE / 2 + 2*borderGap)
                .attr("cy", WORDLE_SIZE / 2 + 2*borderGap)
                .attr("r", WORDLE_SIZE / 2 + borderGap) // 边框半径
                .style("fill", "white")
                .style("stroke", '#AB9587')
                // .style("stroke", themeColor.defaultMode.colorPrimary)
                .style("stroke-width", "1");

            const svg = svgElement
                .append("g")
                .attr("transform", `translate(${WORDLE_SIZE/2 + 2*borderGap}, ${WORDLE_SIZE/2 + 2*borderGap})`) // Adjust as needed
                .attr("clip-path", "url(#wordleMask)"); // 应用遮罩

            const txr = (WORDLE_SIZE/ 2) * 1.1 + 1*borderGap
            const x = (WORDLE_SIZE / 2) * 1.00 + 2*borderGap;
            const y = (WORDLE_SIZE / 2) * 1.00 + 2*borderGap;


            // 添加临时文本以测量长度
            const TITLE_FONT_SIZE = 16
            let tempText = svgElement.append("text")
            .text(wordleTitle)
            .style("font-size", TITLE_FONT_SIZE)
            .style("font-family", "alibaba-puhuiti-bold")
            .attr('opacity', 0); // 使文本不可见)

            let tempNode = tempText.node();
            let textLength = tempNode ? tempNode.getComputedTextLength() : 0;
            let fullCircumference = 2 * Math.PI * txr;

            // console.log("textLength: ", textLength)
            // console.log("fullCircumference: ", fullCircumference)

            // let proportionOfCircle = textLength / fullCircumference;

            // // 如果文本长度超过圆弧的90%，逐步缩短文本直到满足条件
            // let finalText = wordleTitle;
            // if (proportionOfCircle > 0.9) {
            //     for (let i = wordleTitle.length - 1; i > 0; i--) {
            //         finalText = wordleTitle.substring(0, i) + "...";
            //         tempText.text(finalText);
            //         let newTextLength = tempText.node()?.getComputedTextLength() ?? 0;
            //         let newProportionOfCircle = newTextLength / fullCircumference;
            //         if (newProportionOfCircle <= 0.9) {
            //             break; // 找到合适的文本长度，终止循环
            //         }
            //     }
            // } else {
            //     tempText.text(finalText);
            // }

            // 获取最终文本长度
            // tempNode = tempText.node();
            // textLength = tempNode ? tempNode.getComputedTextLength() : 0;

            // 移除临时文本
            tempText.remove();

            // 更新文本比例和角度计算
            let textProportion = textLength / fullCircumference;
            // console.log("textProportion: ", textProportion)

            // 创建一个线性比例尺，将文本长度比例映射到角度
            let angleScale = d3.scaleLinear()
                .domain([-0.5, 0.5]) // 文本长度比例，从0到1
                .range([-Math.PI, Math.PI]); // 完整圆弧的角度范围

            let startAngle = angleScale(-textProportion / 2 * 1); // 将文本居中
            let endAngle = angleScale(textProportion / 2 * 1);
            // console.log("startAngle:", startAngle)
            // console.log("endAngle:", endAngle)

            const textBgArc = d3.arc()
            const textBgArcPath = textBgArc({
                innerRadius: txr+2,
                outerRadius: txr+15,
                startAngle: startAngle,
                endAngle: endAngle
                // startAngle: -Math.PI,
                // endAngle: Math.PI
                });

            // 绘制新的弧形路径
            svgElement.append("path")
            .attr("d", textBgArcPath)
            .attr("id", "TextBgArc")
            .attr('transform', `translate(${x}, ${y})`)
            .attr("fill", "none")
            .attr('text-anchor', 'middle')
            .attr('alignment-baseline', 'central')
            .style("stroke", wordleTitleBgColor)
            .style("stroke-opacity", 0.7)
            .style("stroke-width", "20");

            const arc = d3.arc()
            const arcPath = arc({
                innerRadius: txr,
                outerRadius: txr,
                // startAngle: startAngle,
                // endAngle: endAngle
                startAngle: -Math.PI,
                endAngle: Math.PI
                });

            svgElement.append("path")
            .attr("d", arcPath)
            .attr("id", "textArc")
            .attr('transform', `translate(${x}, ${y})`)
            .attr("fill", "none")
            .attr('stroke', "none");


            svgElement.append("text")
            .attr("x", Math.PI * txr)
            .attr("fill", wordleColor)
            .attr('fill-opacity', 0.8)
            .style("font-size", 16)
            .style("font-size", 20)
            .style('class', 'title')
            .style("font-family", "alibaba-puhuiti-bold") // 设置字体
            // .style("font-weight", "bold")
            .attr('text-anchor', 'middle')
            .attr('alignment-baseline', 'central')
            .append("textPath")
            .attr('href', '#textArc')
            .text(wordleTitle)


            const draw = (drawnWords: VisualizationTypes.WordleTypes.CloudWord[]) => {
                // 过滤掉 text 属性为 undefined 的单词
                const words = drawnWords.filter(d => d.text !== undefined).map((d, index) => ({
                    ...d,
                    text: d.text as string, // 断言 text 不是 undefined
                    id: `word-${d.text}-${index}`, // 给每个单词分配一个唯一ID
                }));

                // console.log('draw', { words });

                // const fill = d3.schemeCategory10;

                svg.selectAll("text")
                    .data(words)
                    .enter().append("text")
                    .attr("class", "wordle_words")
                    .style("font-family", "Impact")
                    .style("stroke-width", 0)
                    .attr("id", d => d.id) // 使用分配的ID作为属性
                    .style('fill-opacity', 0.75)
                    .style("fill", wordleColor)
                    // .style("fill", (d, i) => fill[i % 10])
                    // .style("fill", (d, i) => {
                    //     // 尝试获取颜色对象
                    //     const currentColor = d3.color(fill[i % 10]);
                    //     // 检查 currentColor 是否非空，然后设置透明度
                    //     if (currentColor) {
                    //         d.color = currentColor.toString(); // 保存颜色值到d对象
                    //         currentColor.opacity = 0.6;
                    //         return currentColor.toString(); // 转换回颜色字符串格式
                    //     }

                    //     // 如果 currentColor 为 null，提供一个默认的颜色值
                    //     // 或者根据您的需求选择其他处理方式
                    //     return "rgba(0, 0, 0, 0.6)"; // 示例：默认为半透明黑色
                    // })
                    .attr("text-anchor", "middle")
                    .style("font-size", d => `${d.size}px`)
                    // .attr('fill-opacity', 0.1)
                    .attr("transform", d => `translate(${[d.x, d.y]})rotate(${d.rotate})`)
                    .text(d => d.text)
                    .on('click', (event, d) => {
                    //    console.log('clicked', { word: d });
                    });

                // Sparkline
                // 绘制前三个单词的 sparkline
                const topThreeWords = words.slice(0, 5); // 取前三个单词
                // console.log('topThreeWords: ', topThreeWords)

                topThreeWords.forEach(word => {
                    // console.log('word: ', word)
                    // 假设 word.size 表示词的高度，word.width 表示词的长度
                    // const lineWidth = word.width;
                    // const lineHeight = word.height;
                    const wordElement = document.getElementById(word.id); // 明确指定类型为SVGTextElement

                    if (wordElement instanceof SVGTextElement) { // 检查wordElement不为null
                        const bbox = wordElement.getBBox(); // 获取word元素的bounding box
                        const lineWidth = bbox.width; // 使用word宽度作为线宽
                        const lineHeight = 0.8 * bbox.height; // 使用word高度计算线的最大高度
                        // console.log("bbox:", bbox)


                        let lineData: MainViewTypes.WordleTimelineDataUnit[] = word.timeline; // 获取该词的 timeline 数据
                        // console.log("lineData:", lineData)

                        // case 2-vis (第一段-newsfeed), temp, hard code
                        lineData = lineData.filter((dataUnit: any) => dataUnit.time >= 2005)
                        const xScale = d3.scaleLinear()
                            .domain([2005, 2021]) // timeline 值的范围
                            .range([0, lineWidth]); // SVG 的 y 轴方向是从上到下增大

                        // // case 2-vis (第一段-policy), temp, hard code
                        // lineData = lineData.filter((dataUnit: any) => dataUnit.time <= 2015)
                        // const xScale = d3.scaleLinear()
                        //     .domain([2000, 2015]) // timeline 值的范围
                        //     .range([0, lineWidth]); // SVG 的 y 轴方向是从上到下增大

                        // const xScale = d3.scaleLinear()
                        //     .domain([2000, 2021]) // timeline 值的范围
                        //     .range([0, lineWidth]); // SVG 的 y 轴方向是从上到下增大

                        // 创建一个比例尺来映射 timeline 的值到线条的宽度和高度
                        const maxYValue = d3.max(lineData.map(d => d.value ?? 0)) ?? 0;

                        const yScale = d3.scaleLinear()
                            .domain([0, maxYValue]) // timeline 值的范围
                            .range([lineHeight, 0]); // SVG 的 y 轴方向是从上到下增大

                        const line = d3.line< MainViewTypes.WordleTimelineDataUnit>()
                            .x((d) => xScale(parseInt(d.time))) // 将线条等分
                            .y(d => yScale(d.value))
                            .curve(d3.curveMonotoneX); // 使用平滑曲线


                        // 绘制 Sparkline
                        svg.attr("class", "wordle_sparkline")
                            .append("path")
                            .datum(lineData)
                            .attr("fill", "none")
                            .style('stroke-opacity', 0.7)
                            // .attr("stroke", "black") // 线条颜色
                            // .style("stroke", (d, i) => fill[i % 10])
                            // .style("stroke", word.color || "rgba(0, 0, 0)") // 如果word.color是undefined，则使用默认颜色
                            .style("stroke", wordleColor)
                            .attr("stroke-width", 3.6) // 线条宽度
                            .attr("d", line)
                            .attr("transform", `translate(${word.x - lineWidth / 2}, ${word.y - lineHeight*0.8})`)
                            // .attr("transform", `translate(${word.x - lineWidth / 2}, ${0})rotate(${word.rotate})`)
                            // .attr("transform", `translate(${word.x - lineWidth / 2 + bbox.x}, ${word.y - lineHeight / 2 + bbox.y + bbox.height})rotate(${word.rotate})`);
                            // .attr("transform", `translate(0, 0)`)
                    }
                }
            );

            };

            // const circularLayoutSize = Math.floor(WORDLE_SIZE * 1); // 稍微放大布局区域
            // cloud().size([circularLayoutSize, circularLayoutSize])
            cloud().size([WORDLE_SIZE, WORDLE_SIZE])
                .words(words)
                .padding(PADDING)
                .rotate(() => 0)
                // TODO: font-family in scss
                // .font("Impact")
                .fontSize(d => d.size ?? 10)
                // .spiral("archimedean") // 使用阿基米德螺旋，更适合圆形布局
                .random(() => 0.7) // 固定随机种子，确保布局一致性  // 0.7 -> historical， 0.4/0.6/0.9 -> prediction
                .timeInterval(Infinity) // 禁用动画，完整计算布局
                .on("end", drawnWords => draw(drawnWords as VisualizationTypes.WordleTypes.CloudWord[])) // 使用类型断言确保类型匹配
                .start();
        }
    }, [totalWordleData, wordleEntity, citationFlowType, impactType]);


    return (
      <div className='wordle' style={{
        pointerEvents: "none",
        // // opt 1: general
        // left: wordlePosition.left - 340,
        // top: wordlePosition.top - 100,

        // opt 2: case 2 - vis (policy)
        left: wordlePosition.left - 280,
        top: wordlePosition.top - 300,

        opacity: wordleOpacity,
        zIndex: wordleOpacity === 0 ? -10:10,
        width: WORDLE_SIZE+130,
        height: WORDLE_SIZE+130,
      }} >
        <svg ref={wordleRef} width={WORDLE_SIZE+130} height={WORDLE_SIZE+130} className='wordle-content'
            // viewBox={`${0} ${0} ${WORDLE_SIZE+260} ${WORDLE_SIZE+260}`}
        ></svg>
      </div>
    )
  }

export default Wordle;

